import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import SponsorsPage from "@/pages/SponsorsPage";
import Admin from "@/pages/Admin";
import PaymentStatus from "@/pages/PaymentStatus";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sponsors" element={<SponsorsPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment-status" element={<PaymentStatus />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
